export default __webpack_public_path__ + "static/media/Class_2_Sample_QP.5d94068d.jpg";